module.exports = __webpack_public_path__ + "022767812e03df262628da3907c824f0.svg";